<template lang="pug">
#user_change_custom_plan_modal_wrapper
  b-modal#change-user-custom-plan(title='プランを変更する', 'hide-footer')
    template(v-if="$store.state.user.custom_plan_to_change.widget_imp_limit")
      alert-error(v-if="error", :msg="error_msg")
      template(v-if="$store.state.user.stripe_customer_id")
        p プランを変更します。よろしいでしょうか？
        p.text-sm ※現在のプランの次回更新日までの料金は、変更後のプランの料金と相殺されますので、損することなくプラン変更が可能です。（プランをアップグレードいただいた場合、差額のみを今回追加でお支払いいただき、プランをダウングレードいただいた場合、差額を次回のお支払い時に減額いたします。）
        table.table.mt-3
          thead
            tr
              th(colspan=2) カスタムプラン詳細
          tbody
            tr
              th 支払期間
              td {{pay_cycle($store.state.user.custom_plan_to_change)}}
            tr
              th 料金
              td {{pay_amount($store.state.user.custom_plan_to_change)}}
        .row
          .col-md-12
            .form-group.text-sm
              label(for='coupon_code') クーポンコード
              .input-group
                input#coupon_code.form-control(type='text',
                v-model="coupon_code_form",
                placeholder='')
                span
                  button.btn.btn-success.ml-2(@click="addCoupon") 適用
              span.text-xs.invalid-feedback(v-if="coupon_code_form")  ※クーポンはまだ適用されていません。
              div
                span.text-xs  ※過去に利用したクーポンを再度適用することはできません。
          .col-md-12.mb-4(v-if="$store.state.custom_plan.coupon_code")
            small.badge.badge-success {{ coupon_name }}
              button.btn.btn-tool.btn-tool(@click="removeCoupon")
                i.fas.fa-times.text-white
        .row
          .col-md-3.offset-md-3.col-sm-6.col-xs-6
            template(v-if="!submitting")
              button.btn.btn-success.btn-block(@click="changePlan") はい
            template(v-else)
              button.btn.btn-success.btn-block.disabled はい
          .col-md-3.col-sm-6.col-xs-6
            template(v-if="!submitting")
              button.btn.btn-default.btn-block(@click="cancel") いいえ
            template(v-else)
              button.btn.btn-default.btn-block.disabled いいえ
      template(v-else)
        .callout.callout-danger
          h5 クレジットカードを登録してください。
          p
            | クレジットカード未登録のためプラン登録ができません。
            br
            | 左メニューの「
            i.nav-icon.fa.fa-credit-card.mr-1
            | クレジットカード」
            | よりカードを登録後、再度実行してください

  b-modal#change-custom-plan-success(title='プラン変更が完了しました','hide-footer')
    p ありがとうございました。
  b-modal#change-from-custom-to-basic-plan-success(title='プラン変更が完了しました','hide-footer')
    template(v-if="isNewUi")
      p Basicプランは、サイトリードを利用できるドメイン数が1つに制限されます。
      p プラン変更に伴い、全てのドメインの利用およびサービスを停止しておりますので、利用を継続するドメインとサービスの再開をしてください。
      a(href="/users/tag_domains" style="color: white; background-color: #007bff;") 【利用再開はこちら】
    template(v-else)
      p ありがとうございました。
</template>

<script>
import { mapState } from 'vuex'
import AlertError from '../parts/error.vue'
import { required, url } from 'vuelidate/lib/validators'

import Vue from 'vue'

export default {
  components:{
    AlertError
  },
  props: {
    is_new_ui: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNewUi() {
      return this.is_new_ui
    }
  },
  data(){
    return {
      submitting: false,
      error: false,
      error_msg: "",
      coupon_code_form: "",
      coupon_name: "",
    }
  },
  methods: {
    async changePlan(){
      // this.submitting が true の場合は何もしない
      if(this.submitting) return
      this.submitting=true
      this.error=false
      let oldPlanName = this.$store.state.user.plan_name;
      try{
        await this.$store.dispatch("custom_plan/subscribe", this.$store.state.user.custom_plan_to_change.id)
        let newPlanName = this.$store.state.user.plan_name;
        //this.$toasted.success('カスタムプランを変更しました。')
        this.$store.commit("user/setCurrentCustomPlanId", this.$store.state.user.custom_plan_to_change.id)
        this.$bvModal.hide('change-user-custom-plan')
        if (oldPlanName !== 'basic' && newPlanName === 'basic') {
          this.$bvModal.show('change-from-custom-to-basic-plan-success')
        } else {
          this.$bvModal.show('change-custom-plan-success')
        }
      } catch(e){
        this.error=true
        this.error_msg=e.message
      }
      this.submitting=false
    },
    cancel(){
      this.removeCoupon()
      this.$bvModal.hide('change-user-custom-plan')
    },
    pay_cycle(plan){
      if(plan.interval_name == "month"){
        return "月払い"
      } else if(plan.interval_name == "three_month") {
        return "3ヶ月ごと"
      } else if(plan.interval_name == "six_month"){
        return "6ヶ月ごと"
      } else {
        return "年間払い"
      }

    },
    pay_amount(plan){
      if(plan.interval_name == "month"){
          return plan.amount.toLocaleString('ja-JP') + "円"
      } else if(plan.interval_name == "three_month") {
        return parseInt(plan.amount/3).toLocaleString('ja-JP') + "円 x 3"
      } else if(plan.interval_name == "six_month"){
        return parseInt(plan.amount/6).toLocaleString('ja-JP') + "円 x 6"
      } else {
        return parseInt(plan.amount/12).toLocaleString('ja-JP') + "円 x 12"
      }
    },
    async addCoupon(){
      if (!this.coupon_code_form) return;
      const data = await this.$store.dispatch("custom_plan/checkCouponExists", {
        plan_id: this.$store.state.user.custom_plan_to_change.id,
        coupon_code: this.coupon_code_form,
      })
      console.log(data);
      if (data.error) {
        this.error=true
        this.error_msg=data.error
        this.coupon_code_form = ''
        this.$store.commit("custom_plan/setCouponCode", "")
        return
      } else {
        this.error=false
        this.error_msg=''
        this.coupon_name = data['name']
        this.$store.commit("custom_plan/setCouponCode", this.coupon_code_form)
        this.coupon_code_form = ''
      }
    },
    removeCoupon(){
      this.coupon_code_form = ''
      this.coupon_name = ''
      this.$store.commit("custom_plan/setCouponCode", "")
    },
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
